export default function Divider() {
  return <div className="mt-4 w-full border-t border-gray-300 shadow" />;
}
